import { HTTPStatusCode } from "@libs/api/types";
import {
  AddHouseholdMemberAndRelationshipType,
  HouseholdMemberUpdateType,
} from "@/domain/householdMember";
import { sendSentryError } from "@/services/sentry";
import { tsRestClient } from "@/services/ts-rest";

export const HouseholdMembersApi = {
  listHouseholdMembers: async () => {
    const res = await tsRestClient().householdMembers.listHouseholdMembers();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMembersApi.listHouseholdMembers",
      error: res.body,
      shouldThrowError: true,
    });
  },
  getHouseholdMember: async (id: string) => {
    const res = await tsRestClient().householdMembers.getHouseholdMember({
      params: { id },
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in HouseholdMembersApi.getHouseholdMember",
      error: res.body,
      shouldThrowError: true,
    });
  },
  updateHouseholdMember: async (
    id: string,
    data: HouseholdMemberUpdateType,
  ) => {
    const res = await tsRestClient().householdMembers.updateHouseholdMember({
      params: { id },
      body: data,
    });

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMembersApi.updateHouseholdMember",
      error: res.body,
      shouldThrowError: true,
    });
  },
  addHouseholdMember: async (body: AddHouseholdMemberAndRelationshipType) => {
    const res = await tsRestClient().householdMembers.addHouseholdMember({
      body,
    });
    if (res.status === HTTPStatusCode.CREATED) {
      return res.body;
    }

    sendSentryError({
      message: "Unexpected response in HouseholdMembersApi.addHouseholdMember",
      error: res.body,
      shouldThrowError: true,
    });
  },
  getCurrentHouseholdMember: async () => {
    const res =
      await tsRestClient().householdMembers.getCurrentHouseholdMember();

    if (res.status === HTTPStatusCode.OK) {
      return res.body;
    }

    sendSentryError({
      message:
        "Unexpected response in HouseholdMembersApi.getCurrentHouseholdMember",
      error: res.body,
      shouldThrowError: true,
    });
  },
  deleteHouseholdMember: async (householdMemberId: string) => {
    const res = await tsRestClient().householdMembers.deleteHouseholdMember({
      params: { id: householdMemberId },
    });

    if (res.status === HTTPStatusCode.OK) {
      return;
    }

    sendSentryError({
      error: res.body,
      message:
        "Unexpected response in HouseholdMembersApi.deleteHouseholdMember",
      shouldThrowError: true,
    });
  },
};
